import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-modal-info',
    templateUrl: './modal-info.component.html',
    styleUrls: ['./modal-info.component.css'],
    standalone: false
})
export class ModalInfoComponent {

  @Input() title: string = '';
  @Input() message: string = '';
  @Input() buttonText: string = 'Aceptar';
  isVisible: boolean = false;


  open() {
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
  }

  llamar() {
    window.location.href = 'tel:6006206200';
  }





}
